export const vegMenu = [
  // ===== STARTERS =====
  {
    id: 1,
    title: 'Paneer tikka',
    category: 'starters',
    description: 'Tender cubes of cottage cheese marinated in aromatic spices and grilled to perfection in tandoor',
    rating: 4.8,
    image: '/Images/VEG-STARTERS-MENU/1Paneer tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 2,
    title: 'Haryali paneer tikka',
    category: 'starters',
    description: 'Fresh green marinated paneer tikka with mint, coriander and yogurt, grilled to smoky perfection',
    rating: 4.7,
    image: '/Images/VEG-STARTERS-MENU/2Haryali paneer tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 3,
    title: 'Paneer malai tikka',
    category: 'starters',
    description: 'Creamy and rich paneer marinated in cashew paste, cream and mild spices, grilled to golden perfection',
    rating: 4.9,
    image: '/Images/VEG-STARTERS-MENU/3Paneer malai tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹110',
    basePrice: 110,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 4,
    title: 'Kesariya paneer tikka',
    category: 'starters',
    description: 'Royal saffron-infused paneer tikka with aromatic spices, delivering a rich and exotic flavor',
    rating: 4.6,
    image: '/Images/VEG-STARTERS-MENU/4Kesariya paneer tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 5,
    title: 'Chilli paneer Tikka',
    category: 'starters',
    description: 'Spicy and tangy paneer tikka with bell peppers, onions and chili sauce for a fiery kick',
    rating: 4.5,
    image: '/Images/VEG-STARTERS-MENU/5Chilli paneer Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 6,
    title: 'Malai broccoli tikka',
    category: 'starters',
    description: 'Fresh broccoli florets marinated in creamy malai sauce with mild spices, grilled to perfection',
    rating: 4.4,
    image: '/Images/VEG-STARTERS-MENU/6Malai broccoli tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 7,
    title: 'Tandoori aloo',
    category: 'starters',
    description: 'Spiced baby potatoes marinated in tandoori masala and roasted in clay oven for smoky flavor',
    rating: 4.3,
    image: '/Images/VEG-STARTERS-MENU/7Tandoori aloo.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 8,
    title: 'Stuffed aloo tikka',
    category: 'starters',
    description: 'Crispy potato shells stuffed with spiced cottage cheese and vegetables, grilled to golden brown',
    rating: 4.5,
    image: '/Images/VEG-STARTERS-MENU/8Stuffed aloo tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 9,
    title: 'Soya chaap tikka',
    category: 'starters',
    description: 'Protein-rich soya chaap marinated in tandoori spices and grilled for a meat-like texture and taste',
    rating: 4.6,
    image: '/Images/VEG-STARTERS-MENU/9Soya chaap tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 10,
    title: 'Malai Soya Tikka',
    category: 'starters',
    description: 'Creamy and mild soya chaap marinated in cashew-cream sauce with aromatic herbs and spices',
    rating: 4.7,
    image: '/Images/VEG-STARTERS-MENU/10Malai Soya Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 11,
    title: 'Dry Manchurian',
    category: 'starters',
    description: 'Crispy vegetable balls tossed in dry Manchurian sauce with onions and bell peppers',
    rating: 4.4,
    image: '/Images/VEG-STARTERS-MENU/11Dry Manchurian.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 12,
    title: 'Chilli basil tofu',
    category: 'starters',
    description: 'Crispy tofu cubes tossed in spicy chilli basil sauce with aromatic herbs',
    rating: 4.3,
    image: '/Images/VEG-STARTERS-MENU/12Chilli basil tofu.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 13,
    title: 'Chili Paneer',
    category: 'starters',
    description: 'Indo-Chinese style paneer with bell peppers and onions in spicy chili sauce',
    rating: 4.5,
    image: '/Images/VEG-STARTERS-MENU/13Chili Paneer.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 14,
    title: 'Chilli mushroom',
    category: 'starters',
    description: 'Fresh mushrooms cooked in spicy Indo-Chinese chilli sauce with garlic and ginger',
    rating: 4.4,
    image: '/Images/VEG-STARTERS-MENU/14Chilli mushroom.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 15,
    title: 'Veg shami kabab',
    category: 'starters',
    description: 'Traditional vegetarian shami kabab made with lentils, vegetables and aromatic spices',
    rating: 4.3,
    image: '/Images/VEG-STARTERS-MENU/15Veg shami kabab.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 16,
    title: 'Hara Bhara Kabab',
    category: 'starters',
    description: 'Green vegetable kabab made with spinach, peas and aromatic spices, shallow fried to perfection',
    rating: 4.4,
    image: '/Images/VEG-STARTERS-MENU/16Hara Bhara Kabab.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 17,
    title: 'Dahi ke shole',
    category: 'starters',
    description: 'Crispy yogurt-based fritters with spices and herbs, served hot with mint chutney',
    rating: 4.2,
    image: '/Images/VEG-STARTERS-MENU/17Dahi ke shole.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 18,
    title: 'Dahi ke Kabab',
    category: 'starters',
    description: 'Soft and creamy yogurt kabab with paneer and aromatic spices, shallow fried to golden brown',
    rating: 4.5,
    image: '/Images/VEG-STARTERS-MENU/18Dahi ke Kabab.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 19,
    title: 'Spring Rolls',
    category: 'starters',
    description: 'Crispy vegetable spring rolls filled with fresh vegetables and served with sweet chili sauce',
    rating: 4.3,
    image: '/Images/VEG-STARTERS-MENU/19Spring Rolls.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 20,
    title: 'Spicy veg (crystal dimsum)',
    category: 'starters',
    description: 'Transparent crystal dumplings filled with spicy vegetables and steamed to perfection',
    rating: 4.6,
    image: '/Images/VEG-STARTERS-MENU/20Spicy veg (crystal dimsum).jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 21,
    title: 'Veg momo',
    category: 'starters',
    description: 'Steamed dumplings filled with fresh vegetables and served with spicy chutney',
    rating: 4.3,
    image: '/Images/VEG-STARTERS-MENU/21Veg momo.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 22,
    title: 'Paneer momo',
    category: 'starters',
    description: 'Steamed dumplings filled with spiced paneer and vegetables, served with tangy sauce',
    rating: 4.4,
    image: '/Images/VEG-STARTERS-MENU/22Paneer momo.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 23,
    title: 'Cajun potato',
    category: 'starters',
    description: 'Crispy potato wedges seasoned with Cajun spices and herbs, served with dip',
    rating: 4.2,
    image: '/Images/VEG-STARTERS-MENU/23Cajun potato.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 24,
    title: 'Honey chilli potato',
    category: 'starters',
    description: 'Crispy potato cubes tossed in sweet and spicy honey chilli sauce',
    rating: 4.5,
    image: '/Images/VEG-STARTERS-MENU/24Honey chilli potato.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500GM',
    unit: 'portion'
  },
  {
    id: 25,
    title: 'Cocktail samosa',
    category: 'starters',
    description: 'Mini crispy samosas filled with spiced vegetables, perfect for parties',
    rating: 4.3,
    image: '/Images/VEG-STARTERS-MENU/25Cocktail samosa.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },
  {
    id: 26,
    title: 'Cottage cheese satay',
    category: 'starters',
    description: 'Marinated cottage cheese skewers with bell peppers and onions, grilled to perfection with aromatic spices',
    rating: 4.5,
    image: '/Images/VEG-STARTERS-MENU/26Cottage cheese satay.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10PCS',
    unit: 'portion'
  },

  // ===== MAIN COURSE =====
  {
    id: 27,
    title: 'Paneer Lababdar',
    category: 'main_course',
    description: 'Delicious and authentic preparation with finest ingredients',
    rating: 4.2,
    image: '/Images/MianVegMenu/1Paneer Lababdar.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 28,
    title: 'Kadhai paneer',
    category: 'main_course',
    description: 'Paneer cooked with bell peppers and onions in spicy tomato-based gravy',
    rating: 4.4,
    image: '/Images/MianVegMenu/2Kadhai paneer.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 29,
    title: 'Paneer butter masala',
    category: 'main_course',
    description: 'Rich and creamy paneer curry with butter, tomatoes and aromatic spices',
    rating: 4.6,
    image: '/Images/MianVegMenu/3Paneer butter masala.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 30,
    title: 'Paneer tikka masala',
    category: 'main_course',
    description: 'Grilled paneer tikka cooked in rich tomato and cream-based gravy',
    rating: 4.5,
    image: '/Images/MianVegMenu/4Paneer tikka masala.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 31,
    title: 'Paneer Shahi',
    category: 'main_course',
    description: 'Royal paneer curry with cashews, cream and aromatic Mughlai spices',
    rating: 4.7,
    image: '/Images/MianVegMenu/5Paneer Shahi.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹110',
    basePrice: 110,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 32,
    title: 'Paneer Matar',
    category: 'main_course',
    description: 'Classic combination of paneer and green peas in spiced tomato gravy',
    rating: 4.3,
    image: '/Images/MianVegMenu/6Paneer Matar.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 33,
    title: 'Paneer Palak',
    category: 'main_course',
    description: 'Paneer cubes cooked in creamy spinach gravy with aromatic spices',
    rating: 4.4,
    image: '/Images/MianVegMenu/7Paneer Palak.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 34,
    title: 'Malai kofta',
    category: 'main_course',
    description: 'Deep-fried paneer and potato dumplings in rich creamy tomato gravy',
    rating: 4.6,
    image: '/Images/MianVegMenu/8Malai kofta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 35,
    title: 'Nargisi kofta',
    category: 'main_course',
    description: 'Egg-shaped koftas made with paneer and vegetables in spiced curry',
    rating: 4.3,
    image: '/Images/MianVegMenu/9Nargisi kofta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 36,
    title: 'Korma style kofta',
    category: 'main_course',
    description: 'Vegetable koftas cooked in rich korma-style gravy with cashews and cream',
    rating: 4.5,
    image: '/Images/MianVegMenu/10Korma style kofta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 37,
    title: 'Dum aloo kashmiri',
    category: 'main_course',
    description: 'Baby potatoes cooked in rich Kashmiri-style gravy with yogurt and spices',
    rating: 4.4,
    image: '/Images/MianVegMenu/11Dum aloo kashmiri.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 38,
    title: 'Tawa veg',
    category: 'main_course',
    description: 'Mixed vegetables cooked on tawa with onions, tomatoes and aromatic spices',
    rating: 4.2,
    image: '/Images/MianVegMenu/12Tawa veg.jpg',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 39,
    title: 'Kadhai veg',
    category: 'main_course',
    description: 'Mixed vegetables cooked in kadhai with bell peppers, onions and aromatic spices',
    rating: 4.3,
    image: '/Images/MianVegMenu/13Kadhai veg.jpg',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 40,
    title: 'Mix veg',
    category: 'main_course',
    description: 'Assorted seasonal vegetables cooked in traditional Indian spices and gravy',
    rating: 4.2,
    image: '/Images/MianVegMenu/14Mix veg.jpg',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 41,
    title: 'Matar mushroom',
    category: 'main_course',
    description: 'Fresh mushrooms and green peas cooked in spiced tomato and onion gravy',
    rating: 4.4,
    image: '/Images/MianVegMenu/15Matar mushroom.jpg',
    portionSize: '75GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 42,
    title: 'Methi matar malai',
    category: 'main_course',
    description: 'Fenugreek leaves and green peas cooked in rich creamy malai gravy',
    rating: 4.5,
    image: '/Images/MianVegMenu/16Methi matar malai.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 43,
    title: 'Aloo Gobhi Adraki',
    category: 'main_course',
    description: 'Potato and cauliflower curry with fresh ginger and traditional spices',
    rating: 4.2,
    image: '/Images/MianVegMenu/17Aloo Gobhi Adraki.jpg',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 44,
    title: 'Soya Chaap Masala',
    category: 'main_course',
    description: 'Soya chaap cooked in rich spiced tomato and onion gravy with aromatic herbs',
    rating: 4.4,
    image: '/Images/MianVegMenu/18Soya Chaap Masala.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 45,
    title: 'Dal Makhani',
    category: 'main_course',
    description: 'Rich and creamy black lentils slow-cooked with butter, cream and aromatic spices',
    rating: 4.7,
    image: '/Images/MianVegMenu/19Dal Makhani.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 46,
    title: 'Dal tadka',
    category: 'main_course',
    description: 'Yellow lentils tempered with cumin, garlic, ginger and aromatic spices',
    rating: 4.3,
    image: '/Images/MianVegMenu/20Dal tadka.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 47,
    title: 'Amritsari Chole',
    category: 'main_course',
    description: 'Spicy chickpea curry cooked in Amritsari style with onions, tomatoes and aromatic spices',
    rating: 4.5,
    image: '/Images/MianVegMenu/21Amritsari Chole.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 48,
    title: 'Hakka Noodles',
    category: 'main_course',
    description: 'Stir-fried noodles with vegetables in Indo-Chinese style with soy sauce and spices',
    rating: 4.3,
    image: '/Images/JainMenuMAIN COURSE/7.Hakki Noodles.png',
    portionSize: '75GM',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 49,
    title: 'Veg Manchurian',
    category: 'main_course',
    description: 'Deep-fried vegetable balls in tangy Indo-Chinese sauce with bell peppers and onions',
    rating: 4.4,
    image: '/Images/MianVegMenu/23VegManchurian.jpg',
    portionSize: '75GM',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 50,
    title: 'Veggies in hot garlic',
    category: 'main_course',
    description: 'Mixed vegetables stir-fried in spicy garlic sauce with Indo-Chinese flavors',
    rating: 4.2,
    image: '/Images/MianVegMenu/25Veggies in hot garlic.jpg',
    portionSize: '75GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '375',
    unit: 'portion'
  },
  {
    id: 51,
    title: 'Veg Thai curry',
    category: 'main_course',
    description: 'Mixed vegetables cooked in authentic Thai curry with coconut milk and aromatic herbs',
    rating: 4.4,
    image: '/Images/MianVegMenu/26Veg Thai curry.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹110',
    basePrice: 110,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 52,
    title: 'Pasta – Red',
    category: 'main_course',
    description: 'Italian pasta tossed in tangy red marinara sauce with vegetables',
    rating: 4.3,
    image: '/Images/JainNewImage/Red Pasta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 53,
    title: 'Pasta – White',
    category: 'main_course',
    description: 'Italian pasta in creamy white alfredo sauce with vegetables',
    rating: 4.3,
    image: '/Images/JainNewImage/White Pasta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 54,
    title: 'Pasta Pink',
    category: 'main_course',
    description: 'Italian pasta in rich pink sauce (mix of marinara and alfredo) with vegetables',
    rating: 4.3,
    image: '/Images/JainMenuMAIN COURSE/Pasta Pink.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 55,
    title: 'Pao Bhaaji',
    category: 'main_course',
    description: 'Mumbai street food - spicy mixed vegetable curry served with buttered pao bread',
    rating: 4.6,
    image: '/Images/MianVegMenu/28Pao Bhaaji.jpg',
    portionSize: '100GM + 1.5PC',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500GM + 1.5PC',
    unit: 'portion'
  },
  {
    id: 56,
    title: 'Steamed Rice',
    category: 'main_course',
    description: 'Plain steamed basmati rice, perfect accompaniment to curries and dal',
    rating: 4.1,
    image: '/Images/MianVegMenu/29Steamed Rice.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 57,
    title: 'Jeera Rice',
    category: 'main_course',
    description: 'Fragrant basmati rice cooked with cumin seeds and aromatic spices',
    rating: 4.3,
    image: '/Images/MianVegMenu/30Jeera Rice.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 58,
    title: 'Veg Fried Rice',
    category: 'main_course',
    description: 'Stir-fried rice with mixed vegetables in Indo-Chinese style with soy sauce',
    rating: 4.2,
    image: '/Images/MianVegMenu/31Veg Fried Rice.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 59,
    title: 'Shahi pulao',
    category: 'main_course',
    description: 'Royal basmati rice cooked with dry fruits, saffron and aromatic Mughlai spices',
    rating: 4.5,
    image: '/Images/MianVegMenu/32Shahi pulao.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 60,
    title: 'Peas pulao',
    category: 'main_course',
    description: 'Fragrant basmati rice cooked with green peas and aromatic spices',
    rating: 4.2,
    image: '/Images/MianVegMenu/33Peas pulao.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 61,
    title: 'Veg pulao',
    category: 'main_course',
    description: 'Aromatic basmati rice cooked with mixed vegetables and traditional spices',
    rating: 4.3,
    image: '/Images/MianVegMenu/34Veg pulao.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 62,
    title: 'Veg biryani',
    category: 'main_course',
    description: 'Aromatic basmati rice cooked with mixed vegetables, saffron and traditional biryani spices',
    rating: 4.7,
    image: '/Images/MianVegMenu/35Veg biryani.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },

  // ===== BREADS =====
  {
    id: 63,
    title: 'Tandoori Roti',
    category: 'breads',
    description: 'Delicious and authentic preparation with finest ingredients',
    rating: 4.2,
    image: '/Images/Breads/1Tandoori Roti.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹20',
    basePrice: 20,
    serves: 5,
    quantity: '5',
    unit: 'piece'
  },
  {
    id: 64,
    title: 'Naan',
    category: 'breads',
    description: 'Soft leavened bread cooked in tandoor, served fresh for rich flavor',
    rating: 4.5,
    image: '/Images/Breads/2Naan-Butter Naan.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹30',
    basePrice: 30,
    serves: 5,
    quantity: '5',
    unit: 'piece'
  },
  {
    id: 65,
    title: 'Butter Naan',
    category: 'breads',
    description: 'Soft leavened bread cooked in tandoor, served with butter for rich flavor',
    rating: 4.5,
    image: '/Images/Breads/2Naan-Butter Naan.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹30',
    basePrice: 30,
    serves: 5,
    quantity: '5',
    unit: 'piece'
  },
  {
    id: 66,
    title: 'Lachcha Paratha',
    category: 'breads',
    description: 'Multi-layered flaky bread with crispy texture, perfect with curries and dal',
    rating: 4.4,
    image: '/Images/Breads/3Lachcha Paratha.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹40',
    basePrice: 40,
    serves: 5,
    quantity: '5',
    unit: 'piece'
  },
  {
    id: 67,
    title: 'Garlic Naan',
    category: 'breads',
    description: 'Aromatic naan bread topped with fresh garlic and herbs, baked in tandoor',
    rating: 4.6,
    image: '/Images/Breads/4Garlic Naan.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹45',
    basePrice: 45,
    serves: 5,
    quantity: '5',
    unit: 'piece'
  },
  {
    id: 68,
    title: 'Misi Roti',
    category: 'breads',
    description: 'Traditional gram flour bread with spices and herbs, cooked on tawa',
    rating: 4.3,
    image: '/Images/Breads/5Misi Roti.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹35',
    basePrice: 35,
    serves: 5,
    quantity: '5',
    unit: 'piece'
  },
  {
    id: 69,
    title: 'Tawa Roti',
    category: 'breads',
    description: 'Soft whole wheat flatbread cooked on tawa with ghee, perfect accompaniment to curries',
    rating: 4.3,
    image: '/Images/Breads/6Tawa Roti.jpg',
    portionSize: '2PC',
    pricePerPortion: '₹18',
    basePrice: 18,
    serves: 5,
    quantity: '10',
    unit: 'piece'
  },

  // ===== DESSERTS =====
  {
    id: 70,
    title: 'Gulab Jamun',
    category: 'desserts',
    description: 'Delicious and authentic preparation with finest ingredients',
    rating: 4.2,
    image: '/Images/Desserts/1Gulab Jamun.jpg',
    portionSize: '2PC',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10',
    unit: 'piece'
  },
  {
    id: 71,
    title: 'Brownies',
    category: 'desserts',
    description: 'Rich chocolate brownies with fudgy texture, perfect sweet treat for chocolate lovers',
    rating: 4.4,
    image: '/Images/Desserts/2Brownies.jpg',
    portionSize: '1.5PC',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '7.5',
    unit: 'piece'
  },
  {
    id: 72,
    title: 'Mango Phirni',
    category: 'desserts',
    description: 'Creamy rice pudding infused with fresh mango pulp and garnished with pistachios',
    rating: 4.5,
    image: '/Images/Desserts/3Mango Phirni.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 73,
    title: 'Rasgulla',
    category: 'desserts',
    description: 'Soft and spongy cottage cheese balls soaked in light sugar syrup, a Bengali classic',
    rating: 4.3,
    image: '/Images/Desserts/4Rasgulla.jpg',
    portionSize: '2PC',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10',
    unit: 'piece'
  },
  {
    id: 74,
    title: 'Kheer',
    category: 'desserts',
    description: 'Traditional rice pudding cooked in milk with cardamom, saffron and garnished with almonds',
    rating: 4.4,
    image: '/Images/Desserts/5Kheer.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 75,
    title: 'Moongdal halwa',
    category: 'desserts',
    description: 'Rich and creamy traditional Indian sweet made from yellow lentils, ghee, sugar and garnished with nuts',
    rating: 4.6,
    image: '/Images/Desserts/6Moongdal halwa.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  }
];
export const nonVegMenu = [
  // ===== STARTERS =====
  {
    id: 76,
    title: 'Chicken Tikka',
    category: 'starters',
    description: 'Tender chicken pieces marinated in yogurt and spices, grilled to perfection in tandoor',
    rating: 4.8,
    image: '/Images/NON-VEG MENU-STARTERS/1Chicken Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 77,
    title: 'Haryali chicken tikka',
    category: 'starters',
    description: 'Green marinated chicken tikka with mint, coriander and yogurt, grilled to smoky perfection',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/2Haryali chicken tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 78,
    title: 'Chicken Malai Tikka',
    category: 'starters',
    description: 'Creamy and rich chicken marinated in cashew paste, cream and mild spices, grilled to golden perfection',
    rating: 4.8,
    image: '/Images/NON-VEG MENU-STARTERS/3Chicken Malai Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 79,
    title: 'Chilli Chicken Tikka',
    category: 'starters',
    description: 'Spicy and tangy chicken tikka with bell peppers, onions and chili sauce for a fiery kick',
    rating: 4.5,
    image: '/Images/NON-VEG MENU-STARTERS/4Chilli Chicken Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 80,
    title: 'Anjeeri chicken tikka',
    category: 'starters',
    description: 'Unique chicken tikka marinated with figs and aromatic spices, grilled to perfection',
    rating: 4.6,
    image: '/Images/NON-VEG MENU-STARTERS/5Anjeeri chicken tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 81,
    title: 'Mutton seekh kabab',
    category: 'starters',
    description: 'Minced mutton mixed with aromatic spices and herbs, grilled on skewers in tandoor',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/6Mutton seekh kabab.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 82,
    title: 'Chicken keema & pav',
    category: 'starters',
    description: 'Spiced minced chicken curry served with buttered pav bread, Mumbai street food style',
    rating: 4.6,
    image: '/Images/NON-VEG MENU-STARTERS/7Chicken keema & pav.jpg',
    portionSize: '75GM + 1.5PC',
    pricePerPortion: '₹190',
    basePrice: 190,
    serves: 5,
    quantity: '375GM+1.5PC',
    unit: 'portion'
  },
  {
    id: 83,
    title: 'Chicken seekh kabab',
    category: 'starters',
    description: 'Minced chicken mixed with aromatic spices and herbs, grilled on skewers in tandoor',
    rating: 4.6,
    image: '/Images/NON-VEG MENU-STARTERS/8Chicken seekh kabab.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 84,
    title: 'BBQ Chicken wings',
    category: 'starters',
    description: 'Juicy chicken wings marinated in BBQ sauce and grilled to smoky perfection',
    rating: 4.5,
    image: '/Images/NON-VEG MENU-STARTERS/9BBQ Chicken wings.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 85,
    title: 'Thai chicken satay',
    category: 'starters',
    description: 'Thai-style chicken skewers marinated in coconut milk and spices, grilled and served with peanut sauce',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/10Thai chicken satay.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 86,
    title: 'Amritsari Fish Tikka',
    category: 'starters',
    description: 'Fresh fish marinated in Amritsari spices and gram flour batter, grilled to golden perfection',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 87,
    title: 'Tandoori Prawns',
    category: 'starters',
    description: 'Juicy prawns marinated in tandoori spices and grilled to smoky perfection',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 88,
    title: 'Chili Chicken',
    category: 'starters',
    description: 'Crispy chicken tossed in spicy chili sauce with garlic and peppers',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 89,
    title: 'Chicken fingers',
    category: 'starters',
    description: 'Crispy chicken finger strips, golden-fried and served hot',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 90,
    title: 'Kung pao chicken',
    category: 'starters',
    description: 'Spicy stir-fried chicken with peppers in classic Kung Pao style sauce',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 91,
    title: 'Fish fingers',
    category: 'starters',
    description: 'Crispy battered fish fingers, fried until golden and crunchy',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 92,
    title: 'Fish Otak Otak',
    category: 'starters',
    description: 'Flavorful fish starter prepared in Otak Otak style with aromatic spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹140',
    basePrice: 140,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 93,
    title: 'Chilli garlic prawns',
    category: 'starters',
    description: 'Prawns tossed in spicy chilli garlic sauce with bold Indo-Chinese flavors',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 94,
    title: 'Chilli oil (crystal Dimsums)',
    category: 'starters',
    description: 'Crystal dimsums served with spicy chilli oil',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 95,
    title: 'Chicken spring roll',
    category: 'starters',
    description: 'Crispy chicken spring rolls served hot and crunchy',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 96,
    title: 'Chicken momos',
    category: 'starters',
    description: 'Steamed chicken momos served with spicy chutney',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },
  {
    id: 97,
    title: 'Chicken nuggets',
    category: 'starters',
    description: 'Crispy bite-sized chicken nuggets, fried golden',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-STARTERS/11Amritsari Fish Tikka.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '10',
    unit: 'portion'
  },

  // ===== MAIN COURSE =====
  {
    id: 98,
    title: 'Butter Chicken',
    category: 'main_course',
    description: 'Tender chicken pieces in rich, creamy tomato-based sauce with butter and aromatic spices',
    rating: 4.8,
    image: '/Images/NON-VEG MENU-MAIN COURSE/1Butter Chicken.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 99,
    title: 'Punjabi Chicken',
    category: 'main_course',
    description: 'Authentic Punjabi-style chicken curry with onions, tomatoes and traditional spices',
    rating: 4.6,
    image: '/Images/NON-VEG MENU-MAIN COURSE/2punjabi Chicken.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 100,
    title: 'Chicken Lababdar',
    category: 'main_course',
    description: 'Rich and flavorful chicken curry with cashew paste, cream and aromatic spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/3Chicken Lababdar.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 101,
    title: 'Kadhai chicken',
    category: 'main_course',
    description: 'Kadhai-style chicken cooked with bell peppers, onions and aromatic spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Kadhai chicken.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 102,
    title: 'Chicken do pyaza',
    category: 'main_course',
    description: 'Chicken curry cooked with double the onions (do pyaza) and traditional spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken do pyaza.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 103,
    title: 'Fish curry',
    category: 'main_course',
    description: 'Fresh fish cooked in a flavorful curry gravy with spices and herbs',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Fish curry.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 104,
    title: 'Chicken Curry',
    category: 'main_course',
    description: 'Classic homestyle chicken curry cooked with onions, tomatoes and spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken Curry.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 105,
    title: 'Chicken Rogan Josh',
    category: 'main_course',
    description: 'Kashmiri-style chicken rogan josh with rich gravy and aromatic spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken Rogan Josh.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 106,
    title: 'Chicken korma',
    category: 'main_course',
    description: 'Mild and creamy chicken korma cooked in rich cashew-yogurt gravy',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken korma.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 107,
    title: 'Afgani Chicken',
    category: 'main_course',
    description: 'Creamy Afghani-style chicken curry with mild spices and rich gravy',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Afgani Chicken.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 108,
    title: 'Chicken tikka masala',
    category: 'main_course',
    description: 'Grilled chicken tikka simmered in creamy tomato masala gravy',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken tikka masala.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 109,
    title: 'Mutton rogan josh',
    category: 'main_course',
    description: 'Slow-cooked mutton rogan josh in rich Kashmiri-style gravy with spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Mutton rogan josh.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 110,
    title: 'Handi mutton',
    category: 'main_course',
    description: 'Mutton slow-cooked in handi with rich gravy and traditional spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Handi mutton.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 111,
    title: 'Mutton curry',
    category: 'main_course',
    description: 'Classic mutton curry cooked with onions, tomatoes and aromatic spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Mutton curry.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 112,
    title: 'Malabari Fish Curry',
    category: 'main_course',
    description: 'Coastal Malabari-style fish curry with aromatic spices and rich gravy',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Malabari Fish Curry.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 113,
    title: 'Chicken Noodles',
    category: 'main_course',
    description: 'Stir-fried noodles with chicken and Indo-Chinese sauces',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken Noodles.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 114,
    title: 'Chicken fried rice',
    category: 'main_course',
    description: 'Wok-tossed fried rice with chicken and Indo-Chinese seasonings',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken fried rice.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 115,
    title: 'Chicken Manchurian',
    category: 'main_course',
    description: 'Chicken in tangy Manchurian sauce with Indo-Chinese flavors',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken Manchurian.jpeg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 116,
    title: 'Red Chicken Pasta',
    category: 'main_course',
    description: 'Chicken pasta tossed in tangy red marinara sauce',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Red Chicken Pasta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 117,
    title: 'Pink Chicken Pasta',
    category: 'main_course',
    description: 'Chicken pasta in rich pink sauce (mix of marinara and alfredo)',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Pink Chicken Pasta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 118,
    title: 'White Chicken Pasta',
    category: 'main_course',
    description: 'Chicken pasta in creamy white alfredo sauce',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/White Chicken Pasta.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 119,
    title: 'Chicken biryani',
    category: 'main_course',
    description: 'Aromatic chicken biryani cooked with basmati rice and traditional spices',
    rating: 4.7,
    image: '/Images/NON-VEG MENU-MAIN COURSE/Chicken biryani.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹130',
    basePrice: 130,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
];

